import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import vuexI18n from 'vuex-i18n';
import Locales from './locale/vue-i18n-locales.generated.js';
import { greekUpperFilter, removeGreekAccents } from './utils/greekText'

Vue.use(CoreuiVue)

// Register Greek text filters globally
Vue.filter('greekUpper', greekUpperFilter)
Vue.filter('removeAccents', removeGreekAccents)

// Register directive to automatically remove Greek accents from uppercase elements
Vue.directive('greek-upper', {
  bind(el) {
    // Store original text
    const originalText = el.textContent
    // Remove accents and apply
    el.textContent = removeGreekAccents(originalText)
  },
  update(el) {
    // Update when content changes
    const originalText = el.textContent
    el.textContent = removeGreekAccents(originalText)
  }
})

// Global mixin to remove Greek accents from uppercase elements
Vue.mixin({
  mounted() {
    this.$nextTick(() => {
      // Process elements with text-transform: uppercase
      const upperCaseElements = this.$el.querySelectorAll?.(
        '.table thead th, .badge, .stats-label, .c-sidebar-nav-title, optgroup, .vc-weekday, .dropdown-header'
      ) || []

      upperCaseElements.forEach(el => {
        // Process all text nodes
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false)
        const textNodes = []

        while (walker.nextNode()) {
          textNodes.push(walker.currentNode)
        }

        textNodes.forEach(node => {
          if (node.nodeValue && node.nodeValue.trim()) {
            node.nodeValue = removeGreekAccents(node.nodeValue)
          }
        })
      })
    })
  },
  updated() {
    this.$nextTick(() => {
      // Same processing on update
      const upperCaseElements = this.$el.querySelectorAll?.(
        '.table thead th, .badge, .stats-label, .c-sidebar-nav-title, optgroup, .vc-weekday, .dropdown-header'
      ) || []

      upperCaseElements.forEach(el => {
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false)
        const textNodes = []

        while (walker.nextNode()) {
          textNodes.push(walker.currentNode)
        }

        textNodes.forEach(node => {
          if (node.nodeValue && node.nodeValue.trim()) {
            node.nodeValue = removeGreekAccents(node.nodeValue)
          }
        })
      })
    })
  }
})

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', Locales.en);
Vue.i18n.add('pl', Locales.pl);

let locale = 'en'
if(typeof localStorage.locale !== 'undefined'){
  locale = localStorage.getItem("locale")
}

Vue.i18n.set(locale);

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  }
})

